import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { LoaderState } from './loader';
@Injectable()
export class LoaderService {
    private readonly loaderSubject = new Subject<LoaderState>();
    loaderState = this.loaderSubject.asObservable();

    private readonly loaderHeaderSubject = new Subject<LoaderState>();
    loaderHeaderState = this.loaderHeaderSubject.asObservable();

    private readonly blockUISubject = new BehaviorSubject<boolean>(false);
    blockUI$ = this.blockUISubject.asObservable();
    constructor() { }
    show() {
        this.loaderSubject.next(<LoaderState>{ show: true });
    }
    hide() {
        this.loaderSubject.next(<LoaderState>{ show: false });
    }

    showHeader() {
        this.loaderHeaderSubject.next(<LoaderState>{ show: true });
    }
    hideHeader() {
        this.loaderHeaderSubject.next(<LoaderState>{ show: false });
    }

    setBlockUI(value: boolean) {
        this.blockUISubject.next(value);
    }



    private deratingCallLoadingCount = 0;
    private readonly deratingLoadingSubject = new BehaviorSubject<boolean>(false);

    deratingLoading$ = this.deratingLoadingSubject.asObservable();

    startDeratingLoader() {
        this.deratingCallLoadingCount++;
        this.deratingLoadingSubject.next(true);
    }

    stopDeratingLoader() {
        this.deratingCallLoadingCount = Math.max(0, this.deratingCallLoadingCount - 1);
        this.deratingLoadingSubject.next(this.deratingCallLoadingCount > 0);
    }
}